import { ResourcesConfig } from 'aws-amplify';

const region = process.env.REACT_APP_AWS_REGION as string;
const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID as string;
const userPoolClientId = process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID as string;
const xeniaApiUrl = process.env.REACT_APP_XENIA_API_URL as string;

const awsConfig = {
  Auth: {
    Cognito: {
      region,
      userPoolId,
      userPoolClientId
    }
  },
  API: {
    GraphQL: {
      endpoint: xeniaApiUrl,
      region,
      defaultAuthMode: 'lambda'
    }
  }
} as ResourcesConfig;

export default awsConfig;
